module.exports = __webpack_public_path__ + "static/media/2.a2f99333.webp";